import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';

import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle';
import SEO from '../../components/Seo';
import Services from '../../api/Services';
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import VideoModal from '../../components/ModalVideo/VideoModal';
import Testimonial from '../../components/Testimonial/Testimonial';

import Logo from '../../images/logo2.png';
// import Bgvideo from '../../images/project/work-10.png';

// import dream1 from '../../images/project/work-2.png';
// import dream2 from '../../images/project/work-3.png';
// import dream3 from '../../images/project/work-4.png';
// import dream4 from '../../images/project/work-5.png';

const ServiceSinglePage = () => {
  const { slug } = useParams();
  const serviceSingle = Services.find(item => item.slug === slug);
  console.log('Service Single:', serviceSingle); // Debugging log

  // Safety check
  if (!serviceSingle) return null;

  return (
    <Fragment>
      <SEO
        title={`${serviceSingle.title} | LuxRock Realty Services`}
        description={serviceSingle.overview || `Learn more about ${serviceSingle.title} offered by LuxRock Realty. Trusted real estate experts helping you make safe property decisions.`}
        keywords={`${serviceSingle.title}, LuxRock Realty services, real estate services`}
      />
      <NavbarS4
        hclass={'wpo-site-header wpo-header-style-s11'}
        Logo={Logo}
        col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
        col2={'col-lg-2 col-md-4 col-6'}
        col3={'col-lg-7 col-md-1 col-1'}
        col4={'col-lg-3 col-md-4 col-2'}
      />

      <PageTitle pageTitle={serviceSingle.title} pagesub={'Service'} />
      <ScrollTextAnimation />

      {/* ================= Service Overview ================= */}
      <section className="service-single-page">
        <div className="container-fluid">
          <div
            className="service-image scroll-text-animation"
            data-animation="fade_from_bottom"
          >
            <img src={serviceSingle.SImg} alt={serviceSingle.title} />
          </div>

          <div className="row align-items-center">
            <div className="col-lg-8 col-12">
              <div className="content">
                <h2
                  className="scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  {serviceSingle.title}
                </h2>

                {serviceSingle.overview && (
                  <p
                    className="scroll-text-animation"
                    data-animation="fade_from_bottom"
                  >
                    <span>{serviceSingle.overview.charAt(0)}</span>
                    {serviceSingle.overview.slice(1)}
                  </p>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-12">
              <div
                className="video"
                style={{ backgroundImage: `url(${serviceSingle.Simg6})` }}
              >
                <div className="video-holder">
                  <VideoModal />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= Inner Services ================= */}
      {serviceSingle.innerServices && (
        <section className="service-inner ">
          <div className="container-fluid">
            <div className="section-title">
              <h2
                className="scroll-text-animation"
                data-animation="fade_from_bottom"
              >
                What We Offer
              </h2>
            </div>

            <div className="row">
              {serviceSingle.innerServices.map((item, index) => (
                <div
                  key={index}
                  className="col-lg-3 col-md-6 col-12 scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  <div className="inner-service-card">
                    <h4>{item.name}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ================= Buy / Sell / Rent ================= */}
      {serviceSingle.serviceTypes && (
        <section className="service-types section-padding">
          <div className="container-fluid">
            <div className="section-title">
              <h2
                className="scroll-text-animation"
                data-animation="fade_from_bottom"
              >
                Our Services
              </h2>
            </div>

            <div className="row">
              {serviceSingle.serviceTypes.map((item, index) => (
                <div
                  key={index}
                  className="col-lg-3 col-md-6 col-12 scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  <div className="inner-service-card">
                    <h3>{item.type}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ================= Dream Section (kept as is) ================= */}
      <section className="dream-section">
        <div className="container-fluid">
          <div className="dream-wrap">
            <div className="title">
              <h2>Making Your Dream True!</h2>
              <p>
                At Luxrock Realty, we turn property aspirations into Realty
                through expert guidance, verified listings, and transparent
                processes tailored to your goals.
              </p>
            </div>

            <div className="image-wrap">
              <div className="row">
                <div
                  className="col-lg-6 col-md-6 col-12 scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  <div className="image">
                    <img src={serviceSingle.Simg2} alt="" />
                    {console.log('Service Single Image 2:', serviceSingle.Simg2)} {/* Debugging log */}
                  </div>
                </div>

                <div
                  className="col-lg-6 col-md-6 col-12 scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  <div className="image">
                    <img src={serviceSingle.Simg3} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= Business Section ================= */}
      <section className="service-business section-padding">
        <div className="container-fluid">
          <div className="project-title">
            <div className="row align-items-center">
              <div className="col-lg-6 col-12">
                <h2
                  className="scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  Your Dream, Our Endless Passion
                </h2>
              </div>

              <div className="col-lg-6 col-12">
                <p
                  className="scroll-text-animation"
                  data-animation="fade_from_bottom"
                >
                  Luxrock Realty delivers premium residential, commercial, and
                  industrial real estate solutions backed by trust, expertise,
                  and market insight.
                </p>
              </div>
            </div>
          </div>

          <div className="image-wrap">
            <div className="row">
              <div
                className="col-lg-6 col-md-12 col-12 scroll-text-animation"
                data-animation="fade_from_bottom"
              >
                <div className="image">
                  <img src={serviceSingle.Simg4} alt="" />
                </div>
              </div>

              <div
                className="col-lg-6 col-md-12 col-12 scroll-text-animation"
                data-animation="fade_from_bottom"
              >
                <div className="image">
                  <img src={serviceSingle.Simg5} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Testimonial hclass={'wpo-testimonial-section'} />
      <PartnerSection hclass={'wpo-partners-section fade_bottom'} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ServiceSinglePage;
